export const brandTokens = {
  colorPrimary: "#ff5a36",
  colorPrimaryHover: "#e94727",
  colorPrimaryActive: "#cf351a",
  colorInk: "#242424",
  colorHeading: "#242424",
  colorSurface: "#ffffff",
  colorSurfaceAlt: "#fbfbf9",
  colorLayout: "#f7f7f4",
  colorBorder: "#d8d8d8",
  colorSuccess: "#2f855a",
  colorWarning: "#ff5a36",
  colorError: "#c53030",
  colorInfo: "#ff5a36",
  colorNavBg: "#242424",
  colorNavHover: "#3a3a3a",
  radiusSm: 0,
  radiusMd: 0,
  radiusLg: 0,
  radiusPill: 0,
  spacingXs: 4,
  spacingSm: 8,
  spacingMd: 12,
  spacingLg: 16,
  spacingXl: 24,
} as const;

export const appTheme = {
  token: {
    colorPrimary: brandTokens.colorPrimary,
    colorInfo: brandTokens.colorInfo,
    colorSuccess: brandTokens.colorSuccess,
    colorWarning: brandTokens.colorWarning,
    colorError: brandTokens.colorError,
    borderRadius: brandTokens.radiusLg,
    borderRadiusSM: brandTokens.radiusSm,
    borderRadiusLG: brandTokens.radiusLg,
    borderRadiusXS: 0,
    controlHeight: 44,
    controlHeightLG: 52,
    controlHeightSM: 36,
    fontFamily: 'Inter, "Segoe UI", ui-sans-serif, system-ui, sans-serif',
    colorBgLayout: brandTokens.colorLayout,
    colorBgContainer: brandTokens.colorSurface,
    colorText: brandTokens.colorInk,
    colorTextHeading: brandTokens.colorHeading,
    colorBorder: brandTokens.colorBorder,
  },
  components: {
    Layout: {
      siderBg: brandTokens.colorNavBg,
      headerBg: brandTokens.colorSurfaceAlt,
      bodyBg: brandTokens.colorLayout,
    },
    Menu: {
      darkItemBg: brandTokens.colorNavBg,
      darkSubMenuItemBg: brandTokens.colorNavBg,
      darkItemColor: "#ffffff",
      darkItemHoverBg: brandTokens.colorNavHover,
      darkItemSelectedBg: brandTokens.colorPrimary,
      darkItemSelectedColor: "#ffffff",
    },
    Card: {
      headerBg: brandTokens.colorSurfaceAlt,
      borderRadiusLG: brandTokens.radiusLg,
      paddingLG: 28,
    },
    Button: {
      defaultBorderColor: "#bdbdbd",
      defaultColor: brandTokens.colorInk,
      borderRadius: brandTokens.radiusPill,
      borderRadiusLG: brandTokens.radiusPill,
      borderRadiusSM: brandTokens.radiusPill,
      controlHeight: 44,
      controlHeightLG: 52,
      controlHeightSM: 36,
      fontWeight: 720,
      paddingInline: 24,
      paddingInlineLG: 28,
    },
    Input: {
      borderRadius: brandTokens.radiusSm,
      controlHeight: 44,
      controlHeightLG: 52,
    },
    InputNumber: {
      borderRadius: brandTokens.radiusSm,
      controlHeight: 44,
    },
    Select: {
      borderRadius: brandTokens.radiusSm,
      controlHeight: 44,
      controlHeightLG: 52,
    },
    Tag: {
      borderRadiusSM: brandTokens.radiusPill,
    },
    Tooltip: {
      borderRadius: brandTokens.radiusSm,
      borderRadiusOuter: brandTokens.radiusSm,
      borderRadiusSM: brandTokens.radiusSm,
      borderRadiusXS: brandTokens.radiusSm,
      paddingSM: 6,
      paddingXS: 6,
    },
    Tabs: {
      itemSelectedColor: brandTokens.colorPrimary,
      itemHoverColor: brandTokens.colorPrimaryHover,
      inkBarColor: brandTokens.colorPrimary,
    },
  },
} as const;
